<template>
	<div class="search">
		<img src="@/assets/img/comm/icon_logoLeft.png">
		<div class="search_ri">
			<div class="in">
				<input type="text" v-model="shVal" name="" id="" value="" ref="input_description"
				 @blur="handleEndIpt" @keyup.enter="handleClickEnter" placeholder="在此输入你想要的商品" />
			</div>
			<div class="sear">
				<p class="showHand" @click="handleJj">搜索</p>
			</div>
		</div>
	</div>
</template>

<script>
	let _self;
	export default {
		data() {
			return {
				// 搜索信息
				shVal:null,
			}
		},
		beforeCreate() {
			_self = this;
		},
		methods:{
			//搜索框回车事件
			handleClickEnter(){
				//脱离光标 触发handleEndIpt事件
				this.$nextTick(()=>{
					this.$refs.input_description.blur();
				})
			},
			//脱离光标
			handleEndIpt(){
				//判断是否输入为空，若为空，则不执行下一步
				let newTxt = _self.$commonFun.delTxtLrK(_self.shVal || '');
				if(!newTxt)return;
				//跳转到搜索页面并传递搜索信息
				_self.$router.push({path:'/ShopList',query:{searchVal:_self.shVal}})
			},
			handleJj(){
				
			}
		}
	}
</script>

<style scoped>
	.search {
		width: 1200px;
		margin: 0 auto;
		padding: 40px 0;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.search img {
		width: 190px;
		height: 66px;
		display: block;
	}

	.search_ri {
		width: 900px;
		height: 56px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		border: 2px solid #e62129;
		border-radius: 4px;
	}

	.in input {
		width: 740px;
		height: 56px;
		padding-left: 20px;
		box-sizing: border-box;
		font-size: 20px;
		font-weight: 400;
		text-align: left;
		color: #333333;
		letter-spacing: 2px;
	}

	.sear {
		width: 160px;
		height: 56px;
		background-color: #E62129;
		line-height: 56px;
		text-align: center;
		font-size: 20px;
		font-weight: 400;
		color: #ffffff;
	}
</style>
